module.exports = __webpack_public_path__ + "static/media/tel_icon.7449027c.png";